import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDownload, faTimes} from "@fortawesome/free-solid-svg-icons";

import "./FileListItem.css";

export const FileListItem = ({context, text, showDownloadButton, onDownloadClick, onDeleteClick}) => {

    return (
        <div className="file-list-item-container">
            <div className="file-list-item-text-container">
                {text}
            </div>
            {showDownloadButton && <div
                className="file-list-item-view-button" aria-label={"file-download"}
                onClick={onDownloadClick}>
                <FontAwesomeIcon icon={faDownload}/>
            </div>}
            <div className={context.editMode ? "file-list-item-delete-button" : "disabled-file-list-item-delete-button"}
                 aria-label={"file-delete"} onClick={context.editMode ? onDeleteClick : null}>
                <FontAwesomeIcon icon={faTimes}/>
            </div>
        </div>
    );
}
